// @avantia common-code
import { combineReducers } from 'redux';
import { featureToggleReducer } from '../engineClient/reducers/featureToggleReducer';
import { userInterfaceReducer } from '../engineClient/reducers/userInterfaceReducer';
import { claimEnquiryResultReducer } from './claimEnquiryResultReducer';
import { policiesReducer } from './policyReducer';
import { questionSetReducerExtended } from './reducerExtensions';
import { userReducer } from './userReducer';

const rootReducer = combineReducers({
  userInterface: userInterfaceReducer,
  featureToggles: featureToggleReducer,
  questionSet: questionSetReducerExtended,
  policies: policiesReducer,
  user: userReducer,
  claimEnquiryResult: claimEnquiryResultReducer
});

export { rootReducer };
